export const TIMETABLE = 'TIMETABLE'
export const TIMETABLE_ALL = 'TIMETABLE_ALL'
export const TIMETABLE_GENERATE = 'TIMETABLE_GENERATE'
